import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config: any) => {
    const token = `Bearer ${sessionStorage.getItem("@App:token")}`;
    config.headers['Authorization'] = token;
    config.headers['Content-Type'] = 'application/json';
    return config;
});

api.interceptors.response.use(response => {
    return response;
}, error => {
    debugger;
    const isLoginRequest = error.config?.url?.includes('account/login');
    if (error.response?.status === 401 && !isLoginRequest) {
        sessionStorage.removeItem('@App:token');
        sessionStorage.removeItem('@App:user');
        window.location.href = '/login';
    }
    return Promise.reject(error);
});


export default api;






